import { takeLatest } from 'redux-saga/effects';
import {
  CREATE_INTERVAL,
  DELETE_INTERVAL,
  EDIT_INTERVAL,
  LOAD_CURRENT_INTERVAL_BY_ID,
  LOAD_INTERVAL_LIST,

  CREATE_SUBSCRIPTION,
  DELETE_SUBSCRIPTION,
  EDIT_SUBSCRIPTION,
  LOAD_SUBSCRIPTION_BY_ID,
  LOAD_SUBSCRIPTION_LIST,

  CREATE_SUBSCRIPTION_TYPE,
  DELETE_SUBSCRIPTION_TYPE,
  EDIT_SUBSCRIPTION_TYPE,
  LOAD_SUBSCRIPTION_TYPE_BY_ID,
  LOAD_SUBSCRIPTION_TYPE_LIST,

  CREATE_BLACK_WHITES,
  EDIT_BLACK_WHITES,
  DELETE_BLACK_WHITES,
  LOAD_WHITES_LIST,
  LOAD_BLACK_LIST,
  LOAD_CURRENT_BLACK_WHITES_BY_ID,
  CHECK_BLACK_WHITES_MODULE_STATUS,
} from '../actions';

import { SUBSCRIPTION_MODULE } from '../../../configs/moduleNames';

import loadSubscriptionList from './loadSubscriptionList';
import createSubscription from './createSubscription';
import editSubscription from './editSubscription';
import deleteSubscription from './deleteSubscription';
import loadSubscriptionById from './loadSubscriptionById';
import loadIntervalList from './loadIntervalList';
import loadCurrentIntervalById from './loadCurrentIntervalById';
import createInterval from './createInterval';
import editInterval from './editInterval';
import deleteInterval from './deleteInterval';
import createSubscriptionType from './createSubscriptionType';
import editSubscriptionType from './editSubscriptionType';
import deleteSubscriptionType from './deleteSubscriptionType';
import loadSubscriptionTypeList from './loadSubscriptionTypeList';
import loadSubscriptionTypeById from './loadSubscriptionTypeById';
import createBlackWhites from './blackwhites/createBlackWhites';
import deleteBlackWhites from './blackwhites/deleteBlackWhites';
import editBlackWhites from './blackwhites/editBlackWhites';
import loadWhitesList from './blackwhites/loadWhitesList';
import loadBlackList from './blackwhites/loadBlackList';
import loadCurrentBlackWhitesById from './blackwhites/loadCurrentBlackWhitesById';
import checkBlackWhitesModuleStatus from './blackwhites/checkBlackWhitesModuleStatus';

export default function* sagas() {
  yield takeLatest(SUBSCRIPTION_MODULE + CREATE_SUBSCRIPTION, createSubscription);
  yield takeLatest(SUBSCRIPTION_MODULE + EDIT_SUBSCRIPTION, editSubscription);
  yield takeLatest(SUBSCRIPTION_MODULE + DELETE_SUBSCRIPTION, deleteSubscription);
  yield takeLatest(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_LIST, loadSubscriptionList);
  yield takeLatest(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_BY_ID, loadSubscriptionById);

  yield takeLatest(SUBSCRIPTION_MODULE + CREATE_INTERVAL, createInterval);
  yield takeLatest(SUBSCRIPTION_MODULE + EDIT_INTERVAL, editInterval);
  yield takeLatest(SUBSCRIPTION_MODULE + DELETE_INTERVAL, deleteInterval);
  yield takeLatest(SUBSCRIPTION_MODULE + LOAD_INTERVAL_LIST, loadIntervalList);
  yield takeLatest(SUBSCRIPTION_MODULE + LOAD_CURRENT_INTERVAL_BY_ID, loadCurrentIntervalById);

  yield takeLatest(SUBSCRIPTION_MODULE + CREATE_SUBSCRIPTION_TYPE, createSubscriptionType);
  yield takeLatest(SUBSCRIPTION_MODULE + EDIT_SUBSCRIPTION_TYPE, editSubscriptionType);
  yield takeLatest(SUBSCRIPTION_MODULE + DELETE_SUBSCRIPTION_TYPE, deleteSubscriptionType);
  yield takeLatest(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_TYPE_LIST, loadSubscriptionTypeList);
  yield takeLatest(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_TYPE_BY_ID, loadSubscriptionTypeById);

  yield takeLatest(SUBSCRIPTION_MODULE + CREATE_BLACK_WHITES, createBlackWhites);
  yield takeLatest(SUBSCRIPTION_MODULE + DELETE_BLACK_WHITES, deleteBlackWhites);
  yield takeLatest(SUBSCRIPTION_MODULE + EDIT_BLACK_WHITES, editBlackWhites);
  yield takeLatest(SUBSCRIPTION_MODULE + LOAD_WHITES_LIST, loadWhitesList);
  yield takeLatest(SUBSCRIPTION_MODULE + LOAD_BLACK_LIST, loadBlackList);
  yield takeLatest(SUBSCRIPTION_MODULE + LOAD_CURRENT_BLACK_WHITES_BY_ID, loadCurrentBlackWhitesById);
  yield takeLatest(SUBSCRIPTION_MODULE + CHECK_BLACK_WHITES_MODULE_STATUS, checkBlackWhitesModuleStatus);
}
